import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';

@Injectable({
    providedIn: 'root'
})
export class WalletserviceService {
    constructor() {
    }
}









